import React from 'react';

export default function LogoutForm({logoutFunction, username}) {

    const logout = () => {
        logoutFunction();
    }

    return <div className="LogoutForm row">
        <span className="LogoutForm-username">{username}</span>
        <button className="LogoutForm-button btn btn-primary" onClick={logout}>Logout</button>
    </div>
}
